enum DisplayContextEnum {
    PrimaryDisplay = 1,
    SecondScreen = 2
}

export { DisplayContextEnum };
